export enum Permissions {
  REQUESTER = 'REQUESTER',
  OPERATOR = 'OPERATOR',
  EDITOR = 'EDITOR',
  ADMINISTRATOR = 'ADMINISTRATOR',
}
